import React, { useState } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import AmsTypography from '../../atoms/AmsTypography/AmsTypography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { ListItemSecondaryAction } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
// import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Dialog from '../../atoms/AmsDialog';
import "./list.css"


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
  }),
);

export default function SelectedListItem(props:any) {
  const classes = useStyles();
  
  const {text,icon,selected,handleListClick,index,isPopUp,popupText,isAddress,address} = props
  const [selectedIndex, setSelectedIndex] = React.useState(selected);

    const [openDialog, setOpenDialog] = useState(false);
    const [dialogTitle, setDialogTitle] = useState(text)
    const [dialogContent, setDialogContent] = useState(popupText)
    const handleDialogClick = () => {
        
       
        setOpenDialog(true)
    }

    const handleClose = () => {
        setOpenDialog(false);
    }

  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number,
  ) => {
    handleListClick(event,index)
  };

  return (
    <div className='listroot'>
      <List component="nav" aria-label="main mailbox folders">
        <ListItem
          button
          selected={selected}
          onClick={(event) => handleListItemClick(event, index)}
          className={selected ? "listGreen" : "listBlank"}
        >
          {icon && <ListItemIcon>
            {icon}
          </ListItemIcon>}
          
          <ListItemText className='listText' primary={text} />
          {isAddress?.status && <ListItemSecondaryAction className={selected ? 'address': 'addressDark'}><AmsTypography className='addressText' variant="h6" text={address[`${isAddress?.type}`]} /></ListItemSecondaryAction>}
          {isPopUp &&  <ListItemSecondaryAction onClick={() => handleDialogClick()}>
                    <IconButton edge="end" aria-label="delete">
                      <InfoOutlinedIcon />
                    </IconButton>
                  </ListItemSecondaryAction>}
        </ListItem>
        
      </List>
      <Dialog open={openDialog} title={dialogTitle} content={dialogContent} handleClose={handleClose} />
    </div>
  );
}
